module.exports = [
	{
		"medal": "Rookie",
		"min_range": 0,
		"max_range": 40
	},
	{
		"medal": "Social",
		"min_range": 40.01,
		"max_range": 50
	},
	{
		"medal": "Intermediate",
		"min_range": 50.01,
		"max_range": 60
	},
	{
		"medal": "Solid",
		"min_range": 60.01,
		"max_range": 70
	},
	{
		"medal": "Advanced",
		"min_range": 70.01,
		"max_range": 80
	},
	{
		"medal": "Pro",
		"min_range": 80.01,
		"max_range": 90
	},
	{
		"medal": "Elite Pro",
		"min_range": 90.01,
		"max_range": 100
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LandingPage/medals.json
 ** module id = 2716
 ** module chunks = 0
 **/